var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma-1",
    fill: "#FB5050",
    fillRule: "nonzero",
    d: "M1293.05 32c-6.59 0-12.05 5.362-12.05 11.953 0 6.591 5.46 12.047 12.05 12.047 6.59 0 11.95-5.456 11.95-12.047S1299.64 32 1293.05 32zm4.63 15.099c.43.434.43 1.141 0 1.575-.43.431-1.13.438-1.57 0l-3.08-3.111-3.17 3.112c-.43.434-1.13.434-1.56 0a1.124 1.124 0 010-1.576l3.09-3.111-3.09-3.112a1.124 1.124 0 010-1.576 1.097 1.097 0 011.56 0l3.17 3.113 3.08-3.113a1.11 1.11 0 011.57 0c.43.435.43 1.141 0 1.576l-3.09 3.112 3.09 3.111z",
    transform: "translate(-1281 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.63481aa7a0fe1205ca756b54fbec2935.svg";
export { ForwardRef as ReactComponent };